import React, { useState } from 'react';
import { Link, useNavigate, useLocation, NavLink } from 'react-router-dom';
import { useAdminContext } from '../context/AdminContext';

const Navbar = () => {
  const { logout, admin } = useAdminContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="bg-white border-r border-gray-200 h-full w-64 fixed left-0 top-0 shadow-sm">
      <div className="flex flex-col h-full">
        {/* Logo/Brand */}
        <div className="px-6 py-8 border-b border-gray-200">
        <img 
          src="logo.png" 
          alt="Admin Login" 
          style={{ width: '50%', marginBottom: '1rem' }} 
        />
          <p className="text-sm text-gray-600 mt-1">Admin Dashboard</p>
        </div>

        {/* Navigation Links */}
        <div className="flex-1 px-4 py-6">
          <nav className="space-y-2">
            <Link
              to="/"
              className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg ${
                isActive('/') 
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Dashboard
            </Link>

            <Link
              to="/appointments"
              className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg ${
                isActive('/appointments')
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Appointments
            </Link>

            <Link
              to="/doctors"
              className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg ${
                isActive('/doctors')
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Doctors
            </Link>

            <Link
              to="/patients"
              className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg ${
                isActive('/patients')
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              Patients
            </Link>

            <Link
              to="/contacts"
              className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg ${
                isActive('/contacts')
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-9 4v8m-7-4h14" />
              </svg>
              Contacts
            </Link>
            
            <Link to="/users" className="flex items-center p-2 hover:bg-gray-100 rounded-lg">
              <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Manage Admins
            </Link>
          </nav>
        </div>

        {/* User Profile & Logout */}
       <div className="border-t border-gray-200 p-4">
       <div className="relative">
       <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="w-full flex items-center px-4 py-3 text-sm font-medium text-gray-600 rounded-lg hover:bg-gray-50 focus:outline-none"
    >
      <div className="flex items-center flex-1">
        <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
          <span className="text-primary-700 font-medium text-sm">
            {admin?.name?.charAt(0) || 'A'}
          </span>
        </div>
        <div className="ml-3 text-left">
          <p className="text-sm font-medium text-gray-700">{admin?.name || 'Admin User'}</p>
          <p className="text-xs text-gray-500">{admin?.email}</p>
        </div>
      </div>
      <svg className={`w-5 h-5 ml-2 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    {/* MENU DROPDOWN - DISATUKAN DI SINI */}
    {isDropdownOpen && (
      <div className="absolute bottom-full left-0 w-full mb-2 bg-white rounded-lg shadow-lg border border-gray-200 p-1 z-50">
        
        {/* Tombol Change Password */}
        <button
          onClick={() => {
            setIsDropdownOpen(false);
            navigate('/change-password');
          }}
          className="w-full px-4 py-3 text-sm text-left text-gray-600 hover:bg-gray-50 rounded-lg flex items-center mb-1 transition-colors"
        >
          <svg className="w-5 h-5 mr-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
          Change Password
        </button>

        {/* Garis Pemisah (Opsional) */}
        <div className="border-t border-gray-100 my-1"></div>

        {/* Tombol Logout */}
        <button
          onClick={handleLogout}
          className="w-full px-4 py-3 text-sm text-left text-red-600 hover:bg-red-50 rounded-lg flex items-center transition-colors"
        >
          <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              Logout
            </button>
           </div>
         )}
         </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
